"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var positionSuggestions = function positionSuggestions(a) {
  var b = a.state,
      c = a.props;
  return b.isActive && 0 < c.suggestions.length ? {
    transform: "scaleY(1)",
    transition: "all 0.25s cubic-bezier(.3,1.2,.2,1)"
  } : b.isActive ? {
    transform: "scaleY(0)",
    transition: "all 0.25s cubic-bezier(.3,1,.2,1)"
  } : {};
},
    _default = positionSuggestions;

exports["default"] = _default;